import React from 'react';

const formatBoolean = (data) => <>{String(data)}</>;

export default formatBoolean;
